import { useKeepAwake } from 'expo-keep-awake'
import { observer } from 'mobx-react-lite'
import { useCallback, useEffect, useState } from 'react'
import { AppState, Modal, StyleSheet, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { GameStates } from '@ppwr/poker'
import { useStore } from '../../models'
import { palette } from '../../theme/palette'
import { useConnectToGame, useGameModals, usePokerInfo, useVibration } from '../new-design/hooks'
import { usePreFold } from '../new-design/hooks/usePreFold'
import { ThreeCardBoard } from './ThreeCardBoard'
import { ThreeCardBotPlayers } from './ThreeCardBotPlayers'
import { ThreeCardPlayerHand } from './ThreeCardPlayerHand'
import { ThreeCardTop } from './ThreeCardTop'
import { ModalContent } from '../../components/ANewDesign/ModalContent'
import { GameModal, GameModalKinds, LayerType } from '../../models/game/game-modals'
import { useFocusEffect } from 'expo-router'
import { ThreeCardPlayerActions } from './ThreeCardPlayerActions'

export const ThreeCardGameScreen = observer(() => {
  useKeepAwake(undefined, { suppressDeactivateWarnings: true })
  const { players } = usePokerInfo()
  const [isLoading, setIsLoading] = useState(false)
  const {
    communication: { channel },
    game: { myPlayer, setupGame, pushGameModals, gameState },
    network: { isWebSocketConnected }
  } = useStore()
  const [modalOpened, setModalOpened] = useState(false)

  const { modalConfig, setModalConfig } = useGameModals()

  useEffect(() => {
    const appStateListener = AppState.addEventListener('change', (nextAppState) => {
      if (nextAppState === 'active') {
        setModalConfig(undefined)
      }
    })
    return () => {
      appStateListener.remove()
    }
  }, [setModalConfig])

  useFocusEffect(
    useCallback(() => {
      if (!modalOpened && (!gameState || gameState.tag === GameStates.PreGame.tag)) {
        pushGameModals(
          GameModal.create({
            kind: GameModalKinds.threeCardStart,
            props: {},
            layerType: LayerType.alert // noop
          })
        )
        setModalOpened(true)
      }
    }, [pushGameModals, gameState, modalOpened])
  )

  useVibration()
  usePreFold()
  // TODO: REVIEW THIS, missing properties on the hook, eg. players
  useConnectToGame({
    // players,
    isWebSocketConnected,
    channelName: channel?.channelName
    // isLoading,
    // setIsLoading,
    // setupGame
  })
  const insets = useSafeAreaInsets()

  return (
    <View style={{ flex: 1 }}>
      <View style={[styles.container, { paddingTop: insets.top }]}>
        <ThreeCardTop />
        <View style={[styles.content, { marginTop: insets.top * 2 }]}>
          <View style={{ flex: 0.3, justifyContent: 'center', alignItems: 'center', width: '100%', zIndex: 1 }}>
            <ThreeCardBotPlayers />
          </View>
          <View style={{ flex: 0.9 }}>
            <ThreeCardBoard />
          </View>
          <View style={{ flex: 1 }}>
            <ThreeCardPlayerHand />
          </View>
          <View style={{ flex: 0.5, width: '100%', paddingBottom: insets.bottom }}>
            <ThreeCardPlayerActions actions={myPlayer?.actions ?? []} />
          </View>
        </View>
        <Modal visible={!!modalConfig} animationType="fade" transparent>
          <ModalContent config={modalConfig} />
        </Modal>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    backgroundColor: palette.cream,
    flex: 1,
    gap: 10
  },
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 20
  },
  cardsContainer: {
    // flex: 1
    display: 'flex',
    paddingBottom: '40%'
  },
  bottomSheetHandleStyle: {
    backgroundColor: '#F6F2E9',
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingBottom: 0,
    height: 32
  },
  bottomSheetIndicatorStyle: {
    backgroundColor: 'gray',
    height: 2,
    width: 44
  }
})
